import { useEffect, useRef, useState } from 'react';
import './VdpoHistoryPage.css';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import { Link } from 'react-router-dom';

const historyImages = [
  'ИСТОРИЯ САМАРСКОГО КРАЯ.png',
  'ИСТОРИЯ САМАРСКИХ ПОЖАРНЫХ ЗДАНИЙ.png',
  '1.png',
  '3.png',
  '4.png',
  '5.png',
  '6.png',
  '7.png',
  '8.png',
  '9.png',
  '10.png',
  '12.png',
  '13.png',
  '14.png',
  '15.png',
  '16.png',
  '17.png',
  '18.png',
];

function VdpoHistoryPage() {
  const [selectedImage, setSelectedImage] = useState(null);
  const touchStartXRef = useRef(0);
  const selectedImageIndex = historyImages.findIndex(
    (imageName) => imageName === selectedImage
  );

  function showPreviousImage() {
    if (selectedImageIndex === -1) {
      return;
    }

    const previousIndex =
      (selectedImageIndex - 1 + historyImages.length) % historyImages.length;
    setSelectedImage(historyImages[previousIndex]);
  }

  function showNextImage() {
    if (selectedImageIndex === -1) {
      return;
    }

    const nextIndex = (selectedImageIndex + 1) % historyImages.length;
    setSelectedImage(historyImages[nextIndex]);
  }

  function handleTouchStart(evt) {
    touchStartXRef.current = evt.changedTouches[0].clientX;
  }

  function handleTouchEnd(evt) {
    const touchEndX = evt.changedTouches[0].clientX;
    const swipeDistance = touchEndX - touchStartXRef.current;

    if (Math.abs(swipeDistance) < 40) {
      return;
    }

    if (swipeDistance > 0) {
      showPreviousImage();
      return;
    }

    showNextImage();
  }

  useEffect(() => {
    if (!selectedImage) {
      document.body.style.overflow = '';
      return undefined;
    }

    document.body.style.overflow = 'hidden';
    const previousIndex =
      (selectedImageIndex - 1 + historyImages.length) % historyImages.length;
    const nextIndex = (selectedImageIndex + 1) % historyImages.length;

    const handleKeyDown = (evt) => {
      if (evt.key === 'Escape') {
        setSelectedImage(null);
      }

      if (evt.key === 'ArrowLeft') {
        setSelectedImage(historyImages[previousIndex]);
      }

      if (evt.key === 'ArrowRight') {
        setSelectedImage(historyImages[nextIndex]);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImage, selectedImageIndex]);

  return (
    <>
      <Header />
      <main className="content">
        <section className="vdpoHistory">
          <div className="vdpoHistory__breadcrumbs">
            <Link to="/" className="vdpoHistory__breadcrumbs-link">
              Главная
            </Link>
            <span className="vdpoHistory__breadcrumbs-separator">/</span>
            <span className="vdpoHistory__breadcrumbs-current">
              История развития ВДПО
            </span>
          </div>

          <div className="vdpoHistory__hero">
            <h2 className="vdpoHistory__title">История развития ВДПО</h2>
            <p className="vdpoHistory__lead">
              Подборка материалов и иллюстраций об истории развития ВДПО и
              пожарного дела Самарского края
            </p>
          </div>

          <div className="vdpoHistory__gallery">
            {historyImages.map((imageName) => (
              <figure className="vdpoHistory__card" key={imageName}>
                <button
                  type="button"
                  className="vdpoHistory__button"
                  onClick={() => setSelectedImage(imageName)}
                  aria-label={`Открыть изображение ${imageName.replace(
                    '.png',
                    ''
                  )}`}
                >
                  <img
                    src={`/images/vdpo_history/${imageName}`}
                    alt={`История развития ВДПО: ${imageName.replace(
                      '.png',
                      ''
                    )}`}
                    className="vdpoHistory__image"
                  />
                </button>
              </figure>
            ))}
          </div>
        </section>
      </main>
      {selectedImage && (
        <div
          className="vdpoHistory__lightbox"
          onClick={() => setSelectedImage(null)}
          role="presentation"
        >
          <div
            className="vdpoHistory__lightbox-content"
            onClick={(evt) => evt.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label={`Увеличенное изображение ${selectedImage.replace(
              '.png',
              ''
            )}`}
          >
            <p className="vdpoHistory__lightbox-counter">
              {selectedImageIndex + 1} / {historyImages.length}
            </p>
            <button
              type="button"
              className="vdpoHistory__lightbox-nav vdpoHistory__lightbox-nav_prev"
              onClick={showPreviousImage}
              aria-label="Предыдущее изображение"
            >
              ‹
            </button>
            <button
              type="button"
              className="vdpoHistory__lightbox-close"
              onClick={() => setSelectedImage(null)}
              aria-label="Закрыть изображение"
            >
              ×
            </button>
            <img
              src={`/images/vdpo_history/${selectedImage}`}
              alt={`История развития ВДПО: ${selectedImage.replace(
                '.png',
                ''
              )}`}
              className="vdpoHistory__lightbox-image"
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            />
            <button
              type="button"
              className="vdpoHistory__lightbox-nav vdpoHistory__lightbox-nav_next"
              onClick={showNextImage}
              aria-label="Следующее изображение"
            >
              ›
            </button>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}

export default VdpoHistoryPage;
